<template>
  <vx-timeline :data="timeline" prefix="view_referral.block.timeline.types."></vx-timeline>
</template>

<script>
import moment from 'moment';
import {ResourceImpl} from 'hal-client';
import VxTimeline from '@/components/timeline/VxTimeline';

const acceptedEventTypes = {
  CREATED: {
    icon: 'create',
    iconPack: 'material-icons',
    color: 'warning'
  },
  CREATED_FROM: {
    icon: 'content_copy',
    iconPack: 'material-icons',
    color: 'warning'
  },
  NOTIFICATION_SENT: {
    icon: 'mail',
    iconPack: 'material-icons',
    color: 'warning'
  },
  OPENED: {
    icon: 'drafts',
    iconPack: 'material-icons',
    color: 'primary'
  },
  LINK_CLICKED: {
    icon: 'mouse',
    iconPack: 'material-icons',
    color: 'primary'
  },
  CANCELLED: {
    icon: 'cancel',
    iconPack: 'material-icons',
    color: 'danger'
  },
  ACCEPTED: {
    icon: 'thumb_up',
    iconPack: 'material-icons',
    color: 'success'
  },
  BOUNCED: {
    icon: 'report',
    iconPack: 'material-icons',
    color: 'danger'
  }
};

const eventMapper = (event) => {
  return {
    id: event.id,
    title: event.type,
    desc: moment(event.date).format('YYYY-MM-DD hh:mm A'),
    ...acceptedEventTypes[event.type]
  };
};

const eventFilter = (event) => {
  return acceptedEventTypes[event.type] !== undefined;
};

export default {
  name: 'referral-timeline',
  components: {VxTimeline},
  props: {
    referralResource: ResourceImpl
  },
  data () {
    return {
      timeline: []
    };
  },
  watch: {
    referralResource: {
      immediate: true,
      deep: true,
      handler (next) {
        next.$request().$get('referral-events').then(res => {
          this.timeline = !res.$hasEmbedded('referral-events') ? [] : res.$getEmbedded('referral-events').filter(eventFilter).map(eventMapper);
        });
      }
    }
  }
};
</script>

<style scoped>

</style>
